module.exports = __webpack_public_path__ + "media/images/category/dummy/tops03-df74994b5777fa5020a89decdd6379ec.jpg";